/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Hero_OverlineInputs */

const en_hub_hero_overline = /** @type {(inputs: Hub_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format hub`)
};

const id_hub_hero_overline = /** @type {(inputs: Hub_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat format`)
};

/**
* | output |
* | --- |
* | "Format hub" |
*
* @param {Hub_Hero_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_hero_overline = /** @type {((inputs?: Hub_Hero_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Hero_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_hero_overline(inputs)
	return en_hub_hero_overline(inputs)
});